const keycloakConfig = {
  API_URL: process.env.REACT_APP_API_URL,
  KEYCLOAK_ON: !!process.env.REACT_APP_AUTH_URL,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  IDLE_MINUTES: process.env.REACT_APP_AUTH_IDLE_MINUTES,
  SESSION_STORAGE_AUTH_NAME: 'keycloakToken',
};

export default keycloakConfig;
